module.exports = __webpack_public_path__ + "media/images/gradient-blue-background-3-904fa233150ef53ef3959a0591cc4ebf.png";